import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaPerformanceMenuRegistry = {
    personalize_nebulaPerformance: {
        label: "Nebula Performance",
        link: PAGE_URL.NEBULA_PERFORMANCE_PAGE,
        key: PAGE_URL.NEBULA_PERFORMANCE_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaPerformanceMenuRegistry;
